import styled from 'styled-components';
import {
  screenSize,
  inputBorderColor,
  whiteColor,
  boldFont,
  mediumFont,
  regularFont,
  primaryColor,
  primaryHoverColor,
  appHeaderColor,
} from '@app/styles';
import MunicipalityLogoUrl from '@app/assets/images/Municipalitiesblack.svg';
import ProfileDefaultImageUrl from '@app/assets/images/user_profile.svg';
import Logo from '@app/assets/images/munitechlogo.png';

type Props = {
  color?: 'secondary' | 'success' | undefined;
  active?: boolean;
  image?: string;
  disabled?: boolean;
};

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);
  width: 100%;
  margin-top: 100px;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
    margin-top: 116px;
    height: calc(100vh - 116px);
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const SideNav = styled.div`
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  @media (${screenSize.tablet}) {
    width: 290px;
    height: 100%;
    border-right: 1px solid ${inputBorderColor};
  }
`;

export const DesktopSideNav = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;

export const ListView = styled.div`
  width: 100%;
  height: 100%;
  dispaly: flex;
  flex-direction: column;
  background-color: ${whiteColor};
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 290px);
    height: 100%;
  }
`;
export const Heading = styled.div`
  font-size: 16px;
  color: #110f1f;
  line-height: 24px;
  font-style: normal;
  ${boldFont};
`;

export const ActivityHeading = styled.div`
  font-size: 16px;
  color: #110f1f;
  line-height: 24px;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  ${boldFont};
  @media (${screenSize.tablet}) {
    padding: 40px 24px 0px 40px;
  }
`;

export const FilterBy = styled.div`
  background: #eaecf1;
  padding: 0px 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  color: #2b2b2b;
`;

export const FilterArrow = styled.div`
  background: #d4d8e2;
  opacity: 0.5;
  padding: 0px 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  color: #2b2b2b;
  margin-left: 4px;
`;

export const Filter = styled.div`
  display: flex;
`;
export const NavItem = styled.div`
  @media (${screenSize.tablet}) {
    height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 40px;
    cursor: pointer;
    border-bottom: 1px solid ${inputBorderColor};
  }
`;
export const NavText = styled.div`
  cursor: pointer;
  font-size: 15px;
  color: #110f1f;
  ${({ active }: Props) => {
    if (active) {
      return `
        color: #D63763;
      `;
    }
  }}
`;

export const ListContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin: 0px 40px;
  }
`;

export const MunicipalityContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 22px 0px;
  margin: 0px 10px;
  border-bottom: 1px solid ${inputBorderColor};
  @media (${screenSize.tablet}) {
    margin: 0px;
  }
`;

export const MunicipalityLogo = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f4f5f6;
    min-width: 85px;
    height: 85px;
    border-radius: 50%;
  }
`;
export const MunicipalityMobileLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f6;
  min-height: 85px;
  min-width: 85px;
  border-radius: 50%;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const TaskIcon = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    padding: 22px 16px 22px 16px;
    .fa-check-circle {
      color: #188f71;
      height: 21px;
      width: 21px;
    }
    .fa-circle {
      color: white;
      height: 21px;
      width: 21px;
      border-radius: 50%;
      border: 2px solid #d63763;
    }
  }
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const MunicipalityImage = styled.div`
  width: 40px;
  height: 40px;
  background-position: center;
  background-size: cover;
  ${({ image }: Props) => {
    if (image) {
      return `background-image:url(${image});
              width: 85px;
              height: 85px;
               border-radius: 50%;
          `;
    } else {
      return ` background-image: url(${MunicipalityLogoUrl});
      width: 40px;
      height: 40px;
      `;
    }
  }};
`;
export const ActivityLogContainer = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 290px);
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${whiteColor};
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
export const ActivitylogContainer = styled.div`
  width: 100%;
  // height: calc(100% - 200px);
  height: calc(100% - 300px);
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 0px 0px 40px;
  }
`;
export const ActivityContainer = styled.div`
  @media (${screenSize.tablet}) {
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
export const ActivityMobileContainer = styled.div`
  padding-top: 10px;
  @media (${screenSize.tablet}) {
  }
`;

export const ActivitylogBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 40px 0px 0px;
  }
`;
export const LogName = styled.div`
  font-size: 14px;
  color: #42526e;
  letter-spacing: -0.17px;
  margin-top: 6px;
`;
export const TaskName = styled.span`
  font-size: 15px;
  color: #0a57cd;
  line-height: 21px;
`;
export const CompletedText = styled.span`
  font-size: 15px;
  color: #002200;
  line-height: 21px;
`;
export const LogItem = styled.div`
  padding-top: 5px;
`;
export const CompletedName = styled.span`
  font-size: 14px;
  color: #42526e;
  line-height: 21px;
  ${boldFont};
`;

export const Date = styled.div`
  opacity: 0.6;
  font-size: 15px;
  color: #42526e;
  padding-top: 4px;
`;

export const InvolvedBox = styled.div`
  margin-top: 18px;
`;
export const PropertyInfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: flex-start;
  }
`;
export const InfoBox = styled.div`
  width: 90%;
  margin-left: 10px;
  padding-right: 10px;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    padding-right: 0px;
  }
`;

export const Infocard = styled.div`
  position: relative;
  @media (${screenSize.tablet}) {
    width: 350px;
    margin-right: 20px;
  }
`;

export const ProInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
`;

export const PrimaryInfocard = styled.div`
  position: relative;
  margin-top: 10px;
  @media (${screenSize.tablet}) {
    width: 350px;
    margin-top: 0;
    margin-right: 20px;
  }
`;
export const PurchaseInfocard = styled.div`
  position: relative;
  margin-top: 10px;
  width: 350px;
  @media (${screenSize.tablet}) {
    width: 350px;
    margin-top: 0;
    margin-right: 20px;
  }
`;
export const ModalTextArea = styled.div`
  width: 100%;
  position: relative;
  textarea {
    height: 200px;
  }
  @media (${screenSize.tablet}) {
    width: 80%;
    textarea {
      height: 150px;
    }
  }
`;
export const ExemptTextArea = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 80%;
  }
`;
export const SecondaryInfocard = styled.div`
  // width: 100%;
  width: 200px;
  position: relative;
  margin-top: 10px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 200px;
    margin-top: 0px;
    margin-right: 20px;
  }
`;
export const Label = styled.div`
  font-size: 14px;
  color: #110f1f;
  opacity: 0.5;
  margin-bottom: 4px;
`;
export const CompletedDate = styled.div`
  font-size: 14px;
  color: #110f1f;
  opacity: 0.5;
  margin-top: 10px;
  margin-left: 10px;
  @media (${screenSize.tablet}) {
    margin-bottom: 4px;
    margin-top: 0px;
    margin-left: 0px;
  }
`;

export const PrimaryValue = styled.div`
  font-size: 18px;
  color: #080707;
  letter-spacing: 0;
  line-height: 30px;
  font-style: normal;
  ${boldFont};
`;

export const Value = styled.div`
  font-size: 15px;
  color: #000000;
  line-height: 30px;
`;

export const MlsLinkValue = styled.div`
  font-size: 15px;
  color: #000000;
  line-height: 30px;
  cursor: pointer;
`;

export const MarkValue = styled.div`
  font-size: 15px;
  color: #000000;
  line-height: 30px;
  margin: 0px 20px;
  @media (${screenSize.tablet}) {
    margin: 0px;
  }
`;
export const EqualValue = styled.div`
  font-size: 15px;
  color: #000000;
  line-height: 30px;
  padding-right: 5px;
`;
export const PurchaseValue = styled.div`
  font-size: 18px;
  color: #080707;
  line-height: 30px;
`;

export const PropertyContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid ${inputBorderColor};
  margin: 20px 10px 20px 15px;
  @media (${screenSize.tablet}) {
    margin: 30px 0px 20px 0px;
  }
`;
export const DocumentContainer = styled.div`
  margin: 20px 10px 20px 15px;
  @media (${screenSize.tablet}) {
    margin: 30px 0px 20px 0px;
  }
`;
export const Seperator = styled.div`
  border-bottom: 1px solid ${inputBorderColor};
  margin-top: 20px;
`;
export const InfoContainer = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
export const PropertyIcon = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 85px;
    height: 85px;
    background: #e5e9ee;
    border-radius: 8px;
    margin-right: 20px;
  }
`;
export const PropertyNotesContainer = styled.div`
  width: 100%;
  margin: 10px 0px;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 20px 0px;
  }
`;

export const NotesCard = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 650px;
  }
`;
export const InvolvedContainer = styled.div`
  padding: 5px 15px 10px 15px;
  border-bottom: 1px solid ${inputBorderColor};
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 5px 0px 10px 0px;
  }
`;

export const InvolvedTitle = styled.div`
  font-size: 16px;
  color: #3b4049;
  line-height: 30px;
  font-style: normal;
  ${boldFont};
`;
export const DetailsBox = styled.div`
  width: 100%;
  margin: 5px 0px 0px 0px;
  @media (${screenSize.tablet}) {
    margin: 5px 0px 0px 0px;
  }
`;

export const TaskInfoBox = styled.div`
  width: 82%;
  margin-right:10px;
  @media (${screenSize.tablet}) {
    width: 100%;
     margin-right:0px;
`;

export const DetailsCard = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 0px 0px 20px 0px;
  @media (${screenSize.tablet}) {
    width: 440px;
    padding: 0px 40px 30px 0px;
    margin: 0;
  }
`;

export const InvolvedDetailContainer = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const InvoledDetailBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 140px;
  width: 100%;
  background: #f7f8f9;
  border: 1px solid #dee1e4;
  border-radius: 8px;
  padding-left: 15px;
  paddding-top: 10px;
  @media (${screenSize.tablet}) {
    width: 402px;
    padding: 0px;
    margin: 0;
  }
`;

export const InvolvedImage = styled.div`
margin-left:10px
  @media (${screenSize.tablet}) {
    padding-left: 0px;
  }
`;

export const InvolvedLogo = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin: 20px 14px 0px 20px;
    background-size: cover;
    background-position: center;
    background-image: url(${ProfileDefaultImageUrl});
    ${({ image }: Props) => {
      if (image) {
        return `background-image:url(${image});
             `;
      }
    }}
  }
`;

export const InvolvedMobileLogo = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin: 20px 10px 0px 0px;
    background-size: cover;
    background-position: center;
    background-image: url(${ProfileDefaultImageUrl});
    ${({ image }: Props) => {
      if (image) {
        return `background-image:url(${image});
             `;
      }
    }}
  @media (${screenSize.tablet}) {
   display:none;
  }
`;

export const Text = styled.div`
  padding-top: 14px;
  font-size: 16px;
  color: #110f1f;
  line-height: 24px;
  ${boldFont};
`;
export const PrimaryText = styled.div`
  padding-top: 3px;
  font-size: 15px;
  color: #656a74;
  line-height: 30px;
  padding-bottom: 6px;
`;
export const MobileText = styled.div`
  font-size: 16px;
  color: #110f1f;
  line-height: 30px;
`;
export const SecondaryText = styled.div`
  font-size: 16px;
  color: #110f1f;
  line-height: 30px;
  padding-bottom: 12px;
`;
export const TaskListContainer = styled.div`
  padding: 20px 10px;
  border-bottom: 1px solid ${inputBorderColor};
  @media (${screenSize.tablet}) {
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 30px 0px;
  }
`;

export const ActivityLogMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px 15px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const ChecklistImage = styled.div`
  min-width: 40px;
  min-height: 40px;
  border-radius: 2px;
  margin: 8px 10px 10px 0px;
  border: 1px solid rgba(0, 0, 0, 0.19);
  background-size: cover;
  background-position: center;
  ${({ image }: Props) => {
    if (image) {
      return `background-image:url(${image});
             `;
    }
  }}
   @media (${screenSize.tablet}) {
     min-width: 40px;
    }
`;
export const TaskListBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 12px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 12px;
  }
`;

export const TaskListInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px 0px 0px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 0px;
  }
`;

export const TaskContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;
export const TaskDetailBox = styled.div`
  width: 100%;
  height: 100px;
  @media (${screenSize.tablet}) {
    height: 64px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
  }
`;

export const TaskCard = styled.div`
  padding-left: 15px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 0px;
  }
`;
export const StatusCard = styled.div`
  width: 100%;
  padding-left: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 0px;
  }
`;
export const ImageCard = styled.div`
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 0px;
  }
`;
export const TaskLabel = styled.div`
  font-size: 16px;
  color: #3b4049;
  line-height: 30px;
  ${boldFont};
`;

export const Name = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #4d575f;
  ${regularFont};
`;

export const Status = styled.div`
  font-size: 14px;
  line-height: 30px;
  padding-top:3px;
  ${mediumFont};
  ${({ color }: Props) => {
    if (color === 'secondary') {
      return `
            color: #D63763;
             `;
    } else if (color === 'success') {
      return `
            color: #188f71;
             `;
    }
  }}
   @media (${screenSize.tablet}) {
    text-align:right;
  }
`;

export const ChecklistBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-top: 15px;
  min-height: 75px;
  background: #ffffff;
  border: 1px solid #dfe3e6;
  border-radius: 8px;
  background: #f7f8f9;
  border: 1px solid #dfe3e6;
  @media (${screenSize.tablet}) {
    width: 750px;
    min-height: 64px;
  }
  ${({ color }: Props) => {
    if (color === 'secondary') {
      return `
&:hover {
      background-color: #FEF7FA;
      border-color: #D63763;
    }
             `;
    } else if (color === 'success') {
      return `
&:hover {
      background-color: #f7f8f9;
      border-color: rgb(36,144,116);
    }
             `;
    }
  }}
`;
export const CheckListInstructionsBox = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0px 10px 10px 15px;
  @media (${screenSize.tablet}) {
    padding: 0px 20px 15px 53px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0;
  }
`;

export const ButtonContainer = styled.div`
  cursor: pointer;
  button {
    width: 120px;
  }
  @media (${screenSize.tablet}) {
    margin-left: 15px;
  }
`;
export const ModalContainer = styled.div`
  margin: 0px 10px 0px 10px;
  @media (${screenSize.tablet}) {
    margin: 0px 0px 100px 25px;
  }
`;
export const QuesContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    max-height: 450px;
    width: 95%;
  }
`;
export const ExemptContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 50px;
  max-height: 180px;
  margin-top: 5px;
  margin-bottom: 18px;
  padding-left: 10px;
  padding-top: 18px;
  border-radius: 3px;
  border: 1px solid ${inputBorderColor};
  @media (${screenSize.tablet}) {
    width: 95%;
  }
`;
export const ExemptBox = styled.div`
  @media (${screenSize.tablet}) {
  }
`;
export const ChecklistText = styled.div`
  font-size: 15px;
  color: #110f1f;
  opacity: 0.5;
  line-height: 21px;
  width: 100%;
  ${regularFont}
  padding-left:2px;
  @media (${screenSize.tablet}) {
    padding-left: 0px;
    width: 90%;
  }
`;
export const ChecklistPrimaryText = styled.div`
  font-size: 15px;
  color: rgb(105 110 136);
  line-height: 21px;
  padding-right: 5px;
  ${mediumFont}
`;
export const ChecklistInfoBox = styled.div`
  width: 100%;
  padding-top: 10px;
  @media (${screenSize.tablet}) {
    padding-top: 15px;
  }
`;
export const ExemptInfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
  }
`;
export const RadioItem = styled.div`
  width: 100%;
  position: relative;
  padding-top: 16px;
  @media (${screenSize.tablet}) {
    width: 100px;
    padding-right: 28px;
    margin: 0;
  }
`;
export const ChecklistInfoCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Footer = styled.div`
  height: 85px;
  width: 100%;
  border-top: 0;
  padding: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  @media (${screenSize.tablet}) {
    padding: 0 20px;
    left: 0;
    position: absolute;
    flex-direction: row;
  }
`;
export const ChecklistButtonContainer = styled.div`
  width: 50%;
  margin-right:10px;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    width: 120px;
    margin-right:0px;
  }
`;

export const ExemptButtonContainer = styled.div`
  width: 50%;
  margin-right:15px;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    width: 120px;
    
  }
`;
export const CancelButton = styled.div`
  @media (${screenSize.tablet}) {
    margin-right: 15px;
    width: 100px;
    height: 36px;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #edeff3;
      border-radius: 3px;
      &:hover {
        background: #ccc;
        color: white;
      }
    }
  }
`;

export const ModalInput = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 300px;
  }
`;
export const ModalQuesInput = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 300px;
    padding-left: 12px;
  }
`;

export const SavingIndicator = styled.div`
  right: 30px;
  top: 15px;
  svg {
    path {
      fill: ${primaryColor};
    }
  }
  @media (${screenSize.tablet}) {
    position: absolute;
    left: 30px;
    right: auto;
    top: 35px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;

export const ChecklistImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const EditResponseContainer = styled.div`
  padding-top: 10px;
  @media (${screenSize.tablet}) {
    width: 150px;
  }
`;

export const FileName = styled.div`
  font-size: 12px;
  color: #212a33;
  line-height: 21px;
  padding-bottom: 6px;
  ${regularFont}
  text-overflow: ellipsis;
  @media (${screenSize.tablet}) {
    font-size: 15px;
  }
`;
export const ViewandDownload = styled.div`
  display: flex;
  @media (${screenSize.tablet}) {
    display: flex;
  }
`;
export const ImageText = styled.div`
  font-size: 12px;
  color: #0059b8;
  padding-right: 15px;
  cursor: pointer;
  &:hover {
    color: ${primaryHoverColor};
  }
  ${boldFont}
  a {
    text-decoration: none;
    font-size: 12px;
    color: #0059b8;
    padding-right: 15px;
    cursor: pointer;
    ${boldFont}
    &:hover {
      color: ${primaryHoverColor};
    }
  }
`;
export const EditResponseText = styled.div`
  font-size: 14px;
  color: ${primaryColor};
  text-align: right;
  cursor: pointer;
  ${boldFont}
   @media (${screenSize.tablet}) {
  &:hover {
    color: ${primaryHoverColor};
  }
}
`;

export const TaxValue = styled.div`
  font-size: 14px;
  color: #000000;
  line-height: 30px;
  width: 100px;
  @media (${screenSize.tablet}) {
    width: 150px;
  }
`;

export const TaxText = styled.div`
  font-size: 14px;
  color: #110f1f;
  line-height: 24px;
  ${boldFont};
`;

export const ChecklistBoldText = styled.div`
  font-size: 14px;
  color: #110f1f;
  line-height: 24px;
  ${boldFont};
`;
export const AnsBoldText = styled.div`
  font-size: 14px;
  color: #110f1f;
  line-height: 24px;
  padding-left: 18px;
  ${boldFont};
`;
export const InputCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 302px;
    margin-right: 30px;
  }
`;
export const ModalInfocard = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
  }
`;

export const ProfileImage = styled.div`
  width: 45px;
  height: 45px;
  background-color: rgb(222 228 238);
  background-image: url(${ProfileDefaultImageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const VerifyBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 30px;
`;

export const VerifyCard = styled.div`
  display: flex;
  flex-direction: 'row';
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
`;

export const MarkasCompletedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export const CircularTickIcon = styled.div`
  svg {
    width: 60px;
    height: 60px;
  }
  padding-bottom: 20px;
`;

export const CompletedFooter = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  height: 88px;
  padding: 0 20px;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const CompleteSavingIndicator = styled.div`
  top: 15px;
  svg {
    path {
      fill: ${whiteColor};
    }
  }
  @media (${screenSize.tablet}) {
    padding-right: 50px;
    top: 35px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;
export const MobileHeader = styled.div`
  display: block;
  cursor: pointer;
  @media (${screenSize.desktop}) {
    display: none;
  }
`;
export const MobileDropdown = styled.div`
  position: absolute;
  z-index: 2;
  bottom: 40px;
  right: 15px;
`;
export const MobileDropdownOption = styled.div`
  font-size: 18px;
  display: block;
  color: #100f1f;
  opacity: 1;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 6px;
  line-height: 26px;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
        button{
          background-color:#ccc;
          pointer-events:none;
        }
    `;
    }
  }}
`;
export const MobileOptions = styled.div`
  position: fixed;
  background: #ffffff;
  z-index: 3;
  height: auto;
  top: 100px;
  right: 15px;
  border: 1px solid #dce0e8;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 11px 20px 0 rgb(47 54 65 / 50%);
  @media (${screenSize.tablet}) {
    right: 30px;
    top: 110px;
  }
  @media (${screenSize.desktop}) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column-reverse;
  padding: 0px 10px 20px 0px;
  height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  // width: 100%;
  flex-direction: row;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const MobileExport = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column-reverse;
  padding: 0px 10px 20px 0px;
  height: 60px;
  position: absolute;
  bottom: 0;
  left: 10px;
  // width: 100%;
  flex-direction: row;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const MobileCreate = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${appHeaderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const TitleCompanyLabel = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #110f1f;
  opacity: 0.5;
  margin-top: 20px;
`;
export const TitleCompanyValue = styled.div`
  font-size: 16px;
  line-height: 30px;
  color: #080707;
`;

export const DashedSeperator = styled.div`
  border: 2px dashed #e4e6eb;
  margin-top: 20px;
`;

export const Error = styled.div`
  margin: auto;
  display: flex;
  div {
    margin-left: 5px;
    color: #17335b;
    text-decoration: none;
    cursor: pointer;
    ${boldFont}
  }
`;
